module.exports = require("@calendair/core");